<script setup lang="ts">
  import { trans } from '@bv/utils';

  import CallIntersectionAction from '../../CallIntersectionAction.vue';

  import AnswerHoldIcon from './AnswerHoldIcon.vue';
</script>

<template>
  <call-intersection-action>
    <template #icon>
      <answer-hold-icon />
    </template>
    <template #label>
      {{ trans('voip.calls.call_action.answer_hold_trans') }}
    </template>
  </call-intersection-action>
</template>
